/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-curly-newline */
import { useEffect } from 'react';
import * as React from 'react';
import { Transition } from 'react-transition-group';

import { CloseButton, Overlay, transitionDuration } from '../Base/style';
import { Container, Header, Title } from './style';

const baseZIndex = 1000;

export interface BetPanelBasicProps {
  isOpen: boolean;
  handleClose: () => void;
  walletQueryRefetch?: () => void;
}

export interface BetPanelRefs {
  containerRef: React.RefObject<any>;
  scrollBoxRef: React.RefObject<any>;
}

interface BetPanelBaseProps
  extends BetPanelBasicProps,
    Omit<BetPanelRefs, 'scrollBoxRef'> {}

const BetPanelBase: React.FC<BetPanelBaseProps> = ({
  children,
  isOpen,
  handleClose,
  walletQueryRefetch,
  containerRef,
}) => {
  useEffect(() => {
    if (isOpen && walletQueryRefetch) {
      walletQueryRefetch();
    }
  }, [isOpen]);

  return (
    <Transition
      in={isOpen}
      timeout={transitionDuration}
      mountOnEnter
      unmountOnExit
    >
      {transitionStatus => (
        <Overlay
          transitionStatus={transitionStatus}
          baseZIndex={baseZIndex}
          onClick={() => handleClose()}
        >
          <Container
            transitionStatus={transitionStatus}
            baseZIndex={baseZIndex}
            ref={containerRef}
            onClick={e => e.stopPropagation()}
          >
            <CloseButton
              onClick={() => handleClose()}
              baseZIndex={baseZIndex}
            />
            <Header>
              <Title data-testid="bet-panel-title">投票パネル</Title>
            </Header>
            {children}
          </Container>
        </Overlay>
      )}
    </Transition>
  );
};

export default BetPanelBase;
